import axios from "axios";
import configuration from "./config.json";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const hub_url = process.env.REACT_APP_HUB_URL;

const auth_url = process.env.REACT_APP_AUTH_URL;

var clientId = "comune_bari";

var entityId = "9ca287ff-f114-4c3b-8c8d-8289de59d44d";

const Repo = {
  getListaServizi: (token, flag) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_LISTA_SERVIZI +
        "?idSettore=" +
        flag,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      params: {},
    }),

  getMunicipi: (token) => {
    var config = {
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_MUNICIPI,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    return axios(config);
  },

  getLabels: () => {
    var config = {
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_LABELS,
    };
    return axios(config);
  },

  getIseeList: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISEE_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getTicket: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_TICKETS + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getTicketsUser: (token, userid) => {
    const url =
      hub_url + configuration.HUB_PATH_TICKETS + "/" + userid + "/utente";
    console.log("URL generato:", url);
    console.log("Token:", token);

    return axios({
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  postTicket: (token, ogg) =>
    axios({
      method: "POST",
      url: hub_url + configuration.HUB_PATH_TICKETS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: ogg,
    }),

  modificaTicket: (token, id, ogg) =>
    axios({
      method: "PUT",
      url:
        hub_url + configuration.HUB_PATH_TICKETS + "/" + id + "/" + "modifica",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: ogg,
    }),

  cercaTicket: (token, q) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_TICKETS + "/cerca?q=" + q,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  tuttiTicketAperti: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_TICKETS + "/aperti",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIseeListUploaded: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISEE_LIST_UPLOADED,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIseeListValidated: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISEE_LIST_VALIDATED,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIseeFromInps: (token, userId, dataRicerca) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_GET_INPS}/${userId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      params: dataRicerca ? { dataRicerca } : undefined,
    }),

  getIseeFromInpsDSU: (token, userId, protocolloDSU) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_GET_INPS_DSU}/${userId}/${encodeURIComponent(protocolloDSU)}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }),

  getANPRIns: (token, cf) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_ANPR_INS}/${cf}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }),

  getFindUserAnpr: (token, cf) =>
    axios({
      method: "GET",
      url: `${hub_url}${configuration.HUB_PATH_ANPR_FIND}/${cf}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }),

  postValueIseeOCR: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_VALUE_ISEE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  GetEmailVerfy: (token, email) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_GET_VERIFY_EMAIL + "/" + email,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getIsee: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISEE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  deleteIsee: (token, id) =>
    axios({
      method: "delete",
      url: hub_url + configuration.HUB_PATH_POST_REMOVE_ISEE + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getServices: (token) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_GET_SERVICES_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  getUserServices: (token) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_GET_USER_SERVICES_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  getOneServices: (token, id) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_GET_ONE_SERVICE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postUpdateService: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_SERVICE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postInsertService: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_SERVICES,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  deleteService: (token, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_DELETE_SERVICE + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  postSendIsee: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_SEND_ISEE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postSendIseeOperator: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_SEND_ISEE_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postConfirmIsee: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_CONFIRM_ISEE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

startAggiornamento(token, obb) {
  var config = {
    method: "post",
    url:
      hub_url +
      configuration.HUB_PATH_START_AGGIORNAMENTO,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    data: obb,
  };

  return axios(config);
},



  getUsersList: (token, obb) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_GET_USERS_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: obb,
    }),

  postInsertUser: (token, obb) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_USER,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postRiceviPosizioniDebitorie: (token) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_ALL_EXPORT,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  postRiceviPosizioniDebitorieSblocca: (token) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_ALL_EXPORT,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  postCSVImport: (token, obb, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_IMPORT_CSV + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  getUserOperator: (token, userId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER_OPERATOR + "/" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getPayment: (token, iuv, fiscalCode, referer) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_PAYMENT +
        iuv +
        (fiscalCode ? "?fiscalcode=" + fiscalCode : "") +
        (referer ? "&referer=" + window.location.href : ""),

      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getPagamentiRecenti: (token, giorni) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_OPERATOR_PAYMENT_RECENT +
        "/" +
        giorni,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

    getExcelByIscrizione: (token, iscrizioneId) =>
  axios({
    method: "GET",
    url:
      hub_url +
      configuration.HUB_PATH_GET_EXCEL_BY_ISCRIZIONE +
      "/" +
      iscrizioneId,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }),

  getUserOp: (token, userId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_OPERATOR_GET_USER + "/" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postUpdateUser: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_UPDATE_USER,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postUpdatePosizioneDebitoria: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_UPDATE_PAGAMENTO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postUpdateUserStatus: (token, userId) => {
    console.log(userId);
    var config = {
      method: "post",
      url:
        hub_url + configuration.HUB_PATH_POST_USER_STATUS + "?userId=" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  poutUpdatePaidOp: (token, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_GET_POST_PAYMENT_SUCCESS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  postSendEmail: (token, iuv, userId) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_PAYMENT_SEND_EMAIL +
        "/" +
        iuv +
        "/" +
        userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postSendIO: (token, iuv, userId) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_PAYMENT_SEND_IO +
        "/" +
        iuv +
        "/" +
        userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postDeleteUser: (token, userId) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_DELETE_USER + "/" + userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getUserInfo: async (token) =>
    await axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_USER_INFO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getUsersLoadedCount: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER_STATUS_COUNT_LOADED,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getRangesList: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_RANGES_LIST,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postDeleteRange: (token, rangeId) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_DELETE_RANGE + "?id=" + rangeId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postInsertRange: (token, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_RANGE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  getRangeById: (token, rangeId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_RANGE + "?id=" + rangeId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postUpdateRange: (token, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_RANGE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  getConfiguration: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_CONFIGURATION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postUpdateConfiguration: (token, obj) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_CONFIGURATION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    return axios(config);
  },

  getAnnouncementsByService: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url + configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  generateCsv: (token, id, data) =>
    axios({
      responseType: "arraybuffer",
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_POST_GENERATE_CSV +
        "/" +
        id +
        "?mounth=" +
        data.mese +
        "&year=" +
        data.anno,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "text/csv",
      },
      responseType: "blob",
    }),

  sendMyPay: (token, id, data, fiscalcode) => {
    // Costruzione dell'URL con i parametri mounth e year
    let url =
      hub_url +
      configuration.HUB_PATH_POST_SEND_MYPAY +
      "/" +
      id +
      "?mounth=" +
      data.mese +
      "&year=" +
      data.anno;

    // Aggiunta del parametro fiscalcode solo se non è vuoto o nullo
    if (fiscalcode) {
      url += "&fiscalcode=" + fiscalcode;
    }

    // Creazione della richiesta Axios
    return axios({
      method: "GET",
      url: url,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getAnnouncementsByServiceOperator: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE_OPERATOR +
        "/" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),
  getPagamentiUtenti: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER_PAYMENT,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getPagamentiUtentiOperator: (token, fiscalCode) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_USER_PAYMENT_OPERETOR +
        "?fiscalcode=" +
        fiscalCode,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getAnnouncementsOperator: (token) =>
    axios({
      method: "GET",
      url:
        hub_url + configuration.HUB_PATH_GET_ANNOUNCEMENT_BY_SERVICE_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSelectVersioneServizio: (token) => {
    var config = {
      method: "get",
      url: hub_url + configuration.HUB_PATH_SELECT_VERSIONE_SERVIZIO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postUser: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_USER,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postEmail: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_EMAIL,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postInsertSession: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_INSERT_SESSION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postUpdateSession: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_SESSION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  deleteSession: (token, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_DELETE_SESSION + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getUser: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_USER,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSessionById: (token, sessionId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_SESSION_BY_ID + sessionId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getSessionByIdUser: (token, sessionId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_SESSION_BY_ID_USER + sessionId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  InviaFlussoEmail: (token, identificativoFlusso) =>
    axios({
      method: "POST",
      url:
        hub_url +
        configuration.HUB_PATH_INVIA_EMAIL_FLUSSO +
        "/" +
        identificativoFlusso,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  postSubscribeUserFromOperator: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_SUBSCRIBE_USER_FROM_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  postConfirmUser: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_CONFIRM_DENY_SUBSCRIPTION,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },
  postUnsubscribeAllUsers: (token, announcementId) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_UNSUBSCRIBE_ALL +
        "/" +
        announcementId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  //postUnsubscribeUser(token, id, userId)
  postUnsubscribeUser: (token, id, userId) => {
    var config = {
      method: "post",
      url:
        hub_url +
        configuration.HUB_PATH_POST_UNSUBSCRIBE +
        "/" +
        id +
        "/" +
        "?userId=" +
        userId,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getListaServizi: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_LISTA_SERVIZI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIscrizioni: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ISCRIZIONI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postSubscriptionUser: (token, data) =>
    axios({
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_ISCRIZIONE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: data,
    }),

  postUpdateRanking: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_UPDATE_RANKING,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  getAnnouncementsBacheca: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_ANNOUNCEMENT_BACHECA,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getListSubscription: (token, id) =>
    axios({
      responseType: "arraybuffer",
      method: "GET",
      url: hub_url + configuration.HUB_PATH_POST_EXPORT_SUBSCRIPTION + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "text/csv",
      },
      responseType: "blob",
    }),

  downloadFileOperator: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_DOWNLOAD_FILE_OPERATOR + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  downloadCsvOperator: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_DOWNLOAD_CSV_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  downloadFileUser: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_DOWNLOAD_FILE_USER + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  ValidateCSVByToken: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_VALIDATE_CSV_BY_TOKEN + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getListPaymentOperator: (token, id, fiscalCode) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_LISTA_PAGAMENTI_OPERATOR +
        (fiscalCode ? "?fiscalcode=" + fiscalCode : "?subscriptionId=" + id),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),
  getListPaymentFilterOperator: (token, data) =>
    axios({
      method: "POST",
      url: hub_url + configuration.HUB_PATH_GET_LISTA_PAGAMENTI_FILTRO_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: data,
    }),

  getListPaymentFilterDetailOperator: (token, data) =>
    axios({
      method: "POST",
      url:
        hub_url +
        configuration.HUB_PATH_GET_LISTA_PAGAMENTI_FILTRO_DETTAGLIO_OPERATOR,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: data,
    }),

  getImportStato: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_GET_IMPORT_STATUS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getListPaymentUser: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_LISTA_PAGAMENTI_USER +
        "?subscriptionId=" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),


    downloadGraduatoria:  async (token, id, sovrescrivi) => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${hub_url}${configuration.HUB_PATH_GRADUATORIA_DOWNLOAD}/${id}/${sovrescrivi}`,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          responseType: 'blob', // Indica ad Axios di trattare la risposta come un blob
        });
    
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
    
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'downloaded_file.xlsx';

        if (contentDisposition) {
          const matchUtf8 = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
          if (matchUtf8 && matchUtf8[1]) {
            fileName = decodeURIComponent(matchUtf8[1].trim().replace(/"/g, ''));
          } else {
            const matchQuoted = contentDisposition.match(/filename="([^"]+)"/i);
            const matchSimple = contentDisposition.match(/filename=([^;]+)/i);
            fileName = (matchQuoted?.[1] || matchSimple?.[1] || fileName)
              .trim()
              .replace(/"/g, '');
          }
        }
    
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } catch (error) {
        console.error('Download error:', error);
      }
    },
	
  getIuvUser: (token, id, bool) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_IUV_FILE_USER +
        "/" +
        id +
        "/" +
        bool,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getIuvOperator: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_IUV_FILE_OPERATOR +
        "/" +
        id +
        "/" +
        bool,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postListFlows: (token, data) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_LIST_FLOWS,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config);
  },

  deleteFileOperator: (token, id) => {
    var config = {
      method: "post",
      url: hub_url + configuration.HUB_PATH_POST_DELETE_FILE + "?id=" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  getRendicontazione: (token, id) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_RENDICONTAZIONE +
        "?annuncementId=" +
        id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getResetBando: (token, id) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_RESET_BANDO + "/" + id,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getTotali: (token) =>
    axios({
      method: "GET",
      url:
        hub_url +
        configuration.HUB_PATH_GET_TOTALI +
        "/2025-01-01T00%3A00%3A00",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),


  startAggiornamento: (token, body) =>
    axios({
      method: "POST",
      url: hub_url + configuration.HUB_PATH_START_AGGIORNAMENTO,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: body,
    }),

  getAggiornamentoStatus: (token, jobId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_AGGIORNAMENTI + jobId + "/status",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

  getAggiornamentoLogs: (token, jobId) =>
    axios({
      method: "GET",
      url: hub_url + configuration.HUB_PATH_AGGIORNAMENTI + jobId + "/logs",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }),

getAggiornamentiJobsIsee: (token) =>
  axios({
    method: "GET",
    url:
      hub_url +
      configuration.HUB_PATH_AGGIORNAMENTI_JOBS_ISEE,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }),




    PostRetryAggiornamento: (token, jobId) =>
  axios({
    method: "POST",
    url:
      hub_url +
      configuration.HUB_PATH_AGGIORNAMENTI_JOBS_RETRY +
      jobId, 
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: {},
  }),

      getAggiornamentiBandi: (token) =>
  axios({
    method: "GET",
    url:
      hub_url +
      configuration.HUB_PATH_BANDO_AGGIORNAMENTO,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }),
  






  stopAggiornamento: (token, jobId) =>
  axios({
    method: "POST",
    url:
      hub_url +
      configuration.HUB_PATH_AGGIORNAMENTI +
      jobId +
      "/stop",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: {},
  }),
};

export default Repo;
